import request from 'superagent';

const parseCourseResponse = (res) => JSON.parse(res.text);

/** HTTP 403/404 still include the plan JSON body; return it instead of throwing. */
const parseCourseError = (err) => {
  const text = err?.response?.text;
  if (typeof text === 'string' && text !== '') {
    return JSON.parse(text);
  }
  throw err;
};

export const loadCourseState = (courseCode) =>
  request
    .post('/web_portal/api/v1/course_load_state')
    .type('form')
    .send({ course: courseCode })
    .timeout({
      response: 60000,
      deadline: 90000,
    })
    .then(parseCourseResponse)
    .catch(parseCourseError);

export const saveCourseState = (courseCode, name, value) =>
  request
    .post('/web_portal/api/v1/course_save_state')
    .type('form')
    .send({
      course: courseCode,
      name,
      value,
    })
    .timeout({
      response: 60000,
      deadline: 90000,
    })
    .then(parseCourseResponse)
    .catch(parseCourseError);
